import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Project from "../components/Project";
import "./SideProjects.css";

export default function SideProjects() {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    const basePath = process.env.PUBLIC_URL || '';
    fetch(`${basePath}/data/projects.json`)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => setProjects(data))
      .catch(error => console.error('Error fetching projects data:', error));
  }, []);

  return (
    <div className="side-projects">
      <h1>Side Projects</h1>
      <p className="side-projects-intro">
        Things I build on my own time: games, tools, and experiments. For my professional work, see my <Link to="/resume">resume</Link>.
      </p>
      <div className="projects">
        {projects.map(project => (
          <Project key={project.id} {...project} />
        ))}
      </div>
    </div>
  );
};
